import React, { useState, useContext } from "react";
import "./SuggestionAndRemadies.scss";
import { useTranslation } from "react-i18next";
import BasicDetails from "../BasicDetails";
import KundliInput from "../KundliInput";
import GemSuggestion from "./GemSuggestion";
import PujaSuggestion from "./PujaSuggestion";
import RudrakshaSuggestion from "./RudrakshaSuggestion";
import SadhesatiSuggestion from "./SadhesatiSuggestion";
import Slider from "react-slick";
import { FaArrowCircleLeft, FaArrowCircleRight } from "react-icons/fa";
import { KundliContext } from "../Kundli";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
const SuggestionAndRemadies = () => {
  const { userInfo } = useContext(KundliContext);
  const { t } = useTranslation();
  const [buttonName, setButtonName] = useState("pujaSuggestion");
  const [pujaSuggestionClicked, setPujaSuggestionClicked] = useState(true);
  const [gemSuggestionClicked, setGemSuggestionClicked] = useState(false);
  const [rudrakshaSuggesionClicked, setRudrakshaSuggesionClicked] =
    useState(false);
  const [sadhesatiSuggestionClicked, setSadhesatiSuggestionClicked] =
    useState(false);

  const handleButtons = (setButtonClicked, buttonName) => {
    setPujaSuggestionClicked(false);
    setGemSuggestionClicked(false);
    setRudrakshaSuggesionClicked(false);
    setSadhesatiSuggestionClicked(false);
    setButtonClicked(true);
    setButtonName(buttonName);
  };
  return (
    <>
      <KundliInput />
      {userInfo && Object.keys(userInfo).length !== 0 && (
        <>
          <BasicDetails />
          <Swiper
            modules={[Navigation]}
            navigation
            spaceBetween={10}
            loop={true}
            breakpoints={{
              320: { slidesPerView: 1 },
              768: { slidesPerView: 2 },
              1024: { slidesPerView: 2 },
            }}
          >
            <SwiperSlide>
              <button
                onClick={() =>
                  handleButtons(setPujaSuggestionClicked, "pujaSuggestion")
                }
                type="button"
                className={`suggestion-button w-100 ${
                  buttonName === "pujaSuggestion"
                    ? "suggestion-clicked"
                    : "suggestion-not-clicked"
                }`}
              >
                <small>{t("Puja Suggestion")}</small>
              </button>
            </SwiperSlide>

            <SwiperSlide>
              <button
                onClick={() =>
                  handleButtons(setGemSuggestionClicked, "gemSuggestion")
                }
                type="button"
                className={`suggestion-button w-100 ${
                  buttonName === "gemSuggestion"
                    ? "suggestion-clicked"
                    : "suggestion-not-clicked"
                }`}
              >
                <small>{t("Basic Gem")}</small>
              </button>
            </SwiperSlide>

            <SwiperSlide>
              <button
                onClick={() =>
                  handleButtons(
                    setRudrakshaSuggesionClicked,
                    "rudrakshaSuggestion"
                  )
                }
                type="button"
                className={`suggestion-button w-100 ${
                  buttonName === "rudrakshaSuggestion"
                    ? "suggestion-clicked"
                    : "suggestion-not-clicked"
                }`}
              >
                <small>{t("Rudraksha")}</small>
              </button>
            </SwiperSlide>

            <SwiperSlide>
              <button
                onClick={() =>
                  handleButtons(
                    setSadhesatiSuggestionClicked,
                    "sadhesatiSuggestion"
                  )
                }
                type="button"
                className={`suggestion-button w-100 ${
                  buttonName === "sadhesatiSuggestion"
                    ? "suggestion-clicked"
                    : "suggestion-not-clicked"
                }`}
              >
                <small>{t("Sadhesati")}</small>
              </button>
            </SwiperSlide>
          </Swiper>
          <div className="pt-3 pt-lg-5">
            {pujaSuggestionClicked && <PujaSuggestion />}
            {gemSuggestionClicked && <GemSuggestion />}
            {rudrakshaSuggesionClicked && <RudrakshaSuggestion />}
            {sadhesatiSuggestionClicked && <SadhesatiSuggestion />}
          </div>
        </>
      )}
    </>
  );
};

export default SuggestionAndRemadies;
